import { ScrollableContent } from "@homebound/beam";
import { HistoryFeed } from "src/components";
import { useBidPackageHistoryQuery } from "src/routes/bids/components/BidPackageHistoryTab.generated";
import { queryResult } from "src/utils";

type BidPackageHistoryTabProps = { bidPackageId: string };

export function BidPackageHistoryTab({ bidPackageId }: BidPackageHistoryTabProps) {
  const query = useBidPackageHistoryQuery({ variables: { id: bidPackageId } });
  return queryResult(query, ({ bidPackage }) => (
    <ScrollableContent>
      <HistoryFeed historyItems={bidPackage.history} />
    </ScrollableContent>
  ));
}
